import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { Col, Form, Modal, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { GetLocalStorageValue } from '../../../../../_config/utils/get-local-storage-value.util';
import CustomButton from '../../../../../v2-components/Antd/Button';
import CustomCard from '../../../../../v2-components/Antd/Card';
import CustomInputNumber from '../../../../../v2-components/Antd/InputNumber';
import CustomSelect from '../../../../../v2-components/Antd/Select';
import CustomTable from '../../../../../v2-components/Antd/Table';
import { uid } from '../RecipesModule';
import { MagistralComponentModule } from './components/MagistralComponentModule';
import { Service } from './components/service';


const STATIC_CONTENT = {
  PHARMACEUTICAL_FORM: [
    '-',
    'Aceite Sublingual',
    'Aceite Vaporizable',
    'Base Anhidra',
    'Cápsula',
    'Cápsula A Activo',
    'Colutorio Bucal',
    'Crema',
    'Crema HRT Transdermal',
    'Crema tópica',
    'Enjuague Bucal',
    'FF según receta',
    'Fraccionamiento / Subdivisión MP',
    'Fraccionamiento Comprimidos',
    'Fraccionamiento Cápsulas',
    'Fraccionamiento Polvos',
    'Gel',
    'Gel HRT Transdermal',
    'Inyectable',
    'Jarabe',
    'Laca Base',
    'Loción',
    'Loción Capilar',
    'Loción Cremosa',
    'Loción Dermatológica',
    'Otra',
    'Ovulo Vaginal',
    'Pasta',
    'Pasta Lassar',
    'Papelillo',
    'Sachet',
    'Shampoo Base',
    'Solución',
    'Supositorio Rectal',
    'Suspensión Oral',
    'Unguento',
  ],
  MEASUREMENT_UNIT: ['ml', 'gr', 'Unidad'],
  VEHICLE: [
    '-',
    'MCT', 
    'Oliva', 
    'Maravilla',
    'OG Kush Indica',
    'Amnesia Sativa',
    'Crema HRT', 
    'Gel HRT', 
    'Talco',
    'Almidón',
    'Excipientes en gral',
    'Crema VersaPro Medisca',
    'Crema Fría',
    'Crema Hidratante',
    'Crema Humectante',
    'Crema No Ionica',
    'Crema Oil Free',
    'Gel Base',
    'Novo Base I',
    'Novo Base II',
    'Shampoo Base',
    'Unguento Base',
    'Vaselina Líquida',
    'Vaselina Sólida',
    'Jarabe',
    'Jarabe Simple',
    'Solución Oral',
    'Suspensión'
  ],
  CONTAINER_FORMAT: [
    '-',
    'Frasco',
    'Cartridge',
    'Topiclick Transdérmico',
    'Topiclick Vaginal',
    'Cápsula normal',
    'Cápsula gastroresistente',
    'Cápsula 00',
    'Cápsula 0',
    'Sachets',
    'Pote',
    'Aplicador',
    'Botella',
    'Frasco 15 ml',
    'Frasco 30 ml',
    'Frasco 50 ml',
    'Frasco 100 ml',
    'Cartridge 1 ml',
    'Topiclick Dérmico 35 gr',
    'Topiclick Transvaginal 35 gr',
    'Contenedor 50 gr',
    'Contenedor 100 gr',
    'Aplicador Crema'
  ],
  SPECIFICATION: ['-', 'Sabor carne', 'Sabor salmón', 'Sabor frutilla', 'Sativa', 'Indica'],
};


const MagistralDiscountModal = ({ currentDiscount, onSave }) => {
  const [discount, setDiscount] = useState(currentDiscount || 0);

  return (
    <Form layout="vertical">
      <Form.Item label="Porcentaje de Descuento (%)">
        <CustomInputNumber
          min={0} max={100}
          value={discount}
          onChange={setDiscount}
          formatter={value => `${value}%`}
          parser={value => value.replace('%', '')}
          style={{ width: '100%' }}
        />
      </Form.Item>
      <CustomButton
        type="primary"
        onClick={() => {
          onSave(discount);
          Modal.destroyAll();
        }}
      >
        Aplicar
      </CustomButton>
    </Form>
  );
};



const MagistralToMakeSection = ({
  status,
  products,
  onProductAdd,
  onDelete,
  onUpdateQuantity,
  onUpdatePrice,
  onUpdateDiscount,
  isSearchVisible,
}) => {
  const [form] = Form.useForm();
  const [componentOptions, setComponentOptions] = useState([]);
  const [componentsList, setComponentsList] = useState([{ id: 1 }]);
  const user = GetLocalStorageValue('userInfo')


  const mapStaticOptions = (arr) => arr.map(v => ({ label: v, value: v }));

  const isDisabled = status !== 100;


  useEffect(() => {
    new Service().getProducts()
      .then(data => setComponentOptions(data))
      .catch(console.error);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreateNewComponent = async (name) => {
    const newComponent = await new Service().addComponent({ name: name, token: user?.token })
    setComponentOptions(prev => [...prev, newComponent]);
    return newComponent;
  };


  const handleAddComponent = () => {
    setComponentsList(prev => [...prev, { id: Date.now() }]);
  };

  const handleRemoveComponent = (id) => {
    if (componentsList.length > 1) {
      setComponentsList(prev => prev.filter(c => c.id !== id));
    }
  };

  const handleComponentChange = (id, field, value) => {
    setComponentsList(prev => prev.map(c =>
      c.id === id ? { ...c, [field]: value } : c
    ));
  };


  const generateProductName = (values, components) => {
    const componentNames = components.map(c => {
      const componentObj = componentOptions.find(opt => opt.id === c.component_id);
      return `${componentObj ? componentObj.name : 'N/A'} ${c.concentration_value}${c.concentration_unit}`
    }).join(', ');

    return `${values.form_pharmaceutical} ${values.form_quantity} ${values.form_unit} | ${values.container_format} | ${componentNames} |  ${values.vehicle} | ${values.specification || ''}`;
  };

  const handleSave = () => {
    form.validateFields()
      .then(values => {
        const componentsComplete = componentsList.every(c => c.component_id && c.concentration_value && c.concentration_unit);
        if (!componentsComplete || componentsList.length === 0) {
          Modal.error({ title: "Validación", content: "Debe configurar al menos un componente con todos sus campos." });
          return;
        }

        const enrichedComponents = componentsList.map(c => {
          const compOption = componentOptions.find(opt => opt.id === c.component_id);
          return {
              ...c,
              component_name: compOption ? compOption.name : 'Desconocido'
          };
      });

        const finalProduct = {
          id: uid(),
          name: generateProductName(values, componentsList),
          price_unit: 0,
          quantity: 1,
          discount_percent: 0,
          specifications: values.specification,
          components: enrichedComponents,
          form_pharmaceutical: values.form_pharmaceutical,
          vehicle: values.vehicle,
          container_format: values.container_format,
          form_quantity: values.form_quantity,
          form_unit: values.form_unit,
        };

        onProductAdd(finalProduct);

        form.resetFields();
        setComponentsList([{ id: 1 }]);
      })
      .catch(info => {
        console.log('Validation Failed:', info);
      });
  };

  const columns = [
    {
      title: "Nombre del producto",
      dataIndex: "name",
      key: "name",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={'https://storage.googleapis.com/tirx-resources-production/c12353e0-40ff-4f02-b00a-b58e3ddeff0e.png'}
            alt={'Imagen no disponible'}
            style={{ width: 30, height: 30, marginRight: 10 }}
          />
          <div style={{ padding: '4px 0' }}>
            <p style={{ fontSize: 12 }}>{record.name}</p>
            <div style={{ fontSize: 12, color: "#666" }}>
              <p> Laboratorio Narma</p>
            </div>
          </div>
        </div>
      )
    },
    {
      title: "Cant.",
      dataIndex: "quantity",
      key: "quantity",
      width: 100,
      render: (value, record) => (
        <CustomInputNumber
          disabled={status!==100}
          min={1}
          value={value}
          onChange={(newValue) => onUpdateQuantity(record.id, newValue)}
          style={{ width: '80px' }}
        />
      ),
    },
    {
      title: "Precio u.",
      dataIndex: "price_unit",
      key: "price_unit",
      width: 200,
      render: (val, record) => (
        <CustomInputNumber
        disabled={status!==100}
          min={0}
          value={val || 0}
          onChange={(newValue) => onUpdatePrice(record.id, newValue)}
          formatter={value => {
            if (value === 0 || value === '0') return '$ 0';
            if (!value) return '$ 0';
            return `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          }}
          decimalSeparator=","
          parser={value => value ? value.replace(/\$\s?|\./g, '') : ''}
          style={{ width: '100%', minWidth: '150px' }}
        />
      ),
    },
    {
      title: "Desc. u.",
      dataIndex: "discount_percent",
      key: "discount_percent",
      width: 120,
      render: (discount, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {discount}%
          <CustomButton
           disabled={status!==100}
            icon={<EditOutlined />}
            type="text"
            size="small"
            onClick={() => Modal.info({
              title: 'Aplicar Descuento',
              footer: null,
              content: (
                <MagistralDiscountModal
                  currentDiscount={record.discount_percent}
                  onSave={(newDiscount) => onUpdateDiscount(record.id, newDiscount)}
                />
              ),
              okText: "Aplicar"
            })}
          />
        </div>
      ),
    },
    {
      title: "Precio final U.",
      dataIndex: "price_final_unit",
      key: "price_final_unit",
      width: 140,
      render: (_, record) => `$${(record.price_unit * (1 - (record.discount_percent || 0) / 100)).toFixed(0)}`,
    },
    {
      title: "Precio final",
      dataIndex: "final_price",
      key: "final_price",
      width: 120,
      render: (val) => `$${val?.toFixed(0)}`,
    },
    {
      title: "Eliminar",
      key: "actions",
      width: 80,
      render: (_, record) => (
        <CustomButton
        disabled={status!==100}
          type="text"
          danger
          icon={<DeleteOutlined />}
          onClick={() => onDelete(record.id)}
        />
      ),
    },
  ];
  return (
    <div className="magistral-to-make-section" style={{ marginTop: 16 }}>
      {(isSearchVisible || products.length > 0) && (
        <div style={{ marginBottom: 16, position: "relative", zIndex: 1 }}>
          <CustomTable
                 locale={{
                  emptyText: (
                    <div style={{ padding: '20px 0', color: '#999' }}>
                      <span>Aún no has agregado productos magistrales a confeccionar a tu receta.</span>
                    </div>
                  )
                }}
            columns={columns}
            dataSource={products}
            rowKey="id"
            pagination={false}
          />
        </div>
      )}

      {isSearchVisible && !isDisabled && (
        <CustomCard title="Configuración de Fórmula">
          <Form
            validateMessages={{
              required: "Este campo es obligatorio",
           
            }}
            form={form}
            layout="vertical"
            onFinish={handleSave}
          >
            <Row gutter={16}>
              <Col span={10}>
                <Form.Item name="form_pharmaceutical" label="Forma Farmacéutica" rules={[{ required: true }]}>
                  <CustomSelect options={mapStaticOptions(STATIC_CONTENT.PHARMACEUTICAL_FORM)} placeholder="Seleccionar" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="form_quantity" label="Cantidad" rules={[{ required: true }]}>
                  <CustomInputNumber min={1} placeholder="Unidades" style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="form_unit" label="Unidad de Medida" rules={[{ required: true }]}>
                  <CustomSelect options={mapStaticOptions(STATIC_CONTENT.MEASUREMENT_UNIT)} placeholder="Seleccionar" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <Form.Item name="vehicle" label="Vehículo" rules={[{ required: true }]}>
                  <CustomSelect options={mapStaticOptions(STATIC_CONTENT.VEHICLE)} placeholder="Seleccionar" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="container_format" label="Formato" rules={[{ required: true }]}>
                  <CustomSelect options={mapStaticOptions(STATIC_CONTENT.CONTAINER_FORMAT)} placeholder="Seleccionar" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="specification" label="Especificación (Opcional)">
                  <CustomSelect options={mapStaticOptions(STATIC_CONTENT.SPECIFICATION)} placeholder="Seleccionar" />
                </Form.Item>
              </Col>
            </Row>

            <h4 style={{ marginTop: 20, marginBottom: 10 }}>Módulo Componentes (Activos)</h4>

            {componentsList.map((component, index) => (
              <MagistralComponentModule
                key={component.id}
                componentData={component}
                canDelete={componentsList.length > 1}
                apiComponentOptions={componentOptions}
                onChange={handleComponentChange}
                onRemove={handleRemoveComponent}
                onNewComponentPost={handleCreateNewComponent}
              />
            ))}

            <CustomButton
              icon={<PlusOutlined />}
              type="dashed"
              onClick={handleAddComponent}
              style={{ width: '100%', marginTop: 8 }}
            >
              Agregar Nuevo Componente
            </CustomButton>


            <Row gutter={16} align="middle">

              <Col span={8}>
                <CustomButton type="primary" htmlType="submit" size="large" style={{ marginTop: 10, width: '100%' }}>
                  Guardar Producto
                </CustomButton>
              </Col>
            </Row>

          </Form>
        </CustomCard>
      )}
    </div>
  );
};

export default MagistralToMakeSection;